import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// components
import FormField from './../Forms/FormField/FormField';
import AddOption from './AddOption/AddOption';
// css
import './AddQuestion.scss';
//editor for reason field
import RichTextEditor from 'react-rte';

const AddQuestion = ({
	onChange, question, options, reason, url, onChangeOption, onCreateOption,
	onDestroyOption, onToggleCorrectOption, onChangeReason
}) => {
	const [initialCount, setCount] = useState(options.length);

	const [reasonValue, setReasonValue] = useState(RichTextEditor.createValueFromString(reason, 'html'));
	
	useEffect(() => {
		setCount( options.length );
		setReasonValue(RichTextEditor.createValueFromString(reason, 'html'));
	},[options.length, question]);

	const addOption = () => {
		onCreateOption();
	}

	const removeOption = () => {
		onDestroyOption(initialCount - 1);
	}

	const renderOptions = (count) => {
		let rows = [];
		for (var i = 0; i < count; i++) {
			rows.push(
				<AddOption
					key={i}
					currentCount={i}
					maxCount={count}
					onadd={addOption}
					onRemove={removeOption}
					option={options[i]}
					onChangeOption={onChangeOption}
					onToggleCorrectOption={onToggleCorrectOption}
				/>
			);
		}
		return rows;
	}

	// useEffect(() => {
	// 	setReasonValue(RichTextEditor.createValueFromString(reason, 'html'));
	// 	console.log(reason);
	// }, [reason]);

	const onChangeRichText = (v) => {
		setReasonValue(v);
		onChangeReason(v.toString('html'));
	}

	return (
		<div className='AddQuestion'>
			<FormField
				label="question"
				name="question"
				type="text"
				multiline
				rows={6}
				placeholder="enter Question"
				value={question}
				onChange= {onChange}
				validate={['required']}
			/>
			{renderOptions(initialCount)}
			{
				options
				&& options.length > 0
				&& options.some((item) => item.option_value !== '')
				&& !options.some((item) => item.correct_answer === 'Y')
				&& <div className="static-note">Please select atleast one correct answer</div>
			}
			{/* <FormField
				label="reason"
				name="reason"
				type="text"
				multiline
				rows={6}
				placeholder="enter reason"
				value={reason}
				onChange= {onChange}
			/> */}
			<div className='label'>reason</div>
			<RichTextEditor value={reasonValue} onChange={v => onChangeRichText(v)} />

			<FormField
				label="URL"
				name="url"
				type="text"
				placeholder="enter URL"
				value={url}
				onChange= {onChange}
				validate={['validUrl']}
			/>
		</div>
	);
}

AddQuestion.propTypes = {
	onChange: PropTypes.func,
	question: PropTypes.string,
	options: PropTypes.instanceOf(Array),
	onChangeOption: PropTypes.func,
	onCreateOption: PropTypes.func,
	onDestroyOption: PropTypes.func,
    onToggleCorrectOption: PropTypes.func
};

AddQuestion.defaultProps = {
    onChange: () => {},
	question: 'PropTypes.string',
	options: [],
	onChangeOption: () => {},
	onCreateOption: () => {},
	onDestroyOption: () => {},
    onToggleCorrectOption: () => {}
};

export default AddQuestion;



// WEBPACK FOOTER //
// ./common/AddQuestion/AddQuestion.js